module.exports = __webpack_public_path__ + "img/poll-alt.e5f8b27a.svg";